
// export const APIDomain = 'http://localhost:8080/'
// export const APIDomain = 'https://us-central1-exsportia-dev.cloudfunctions.net/develop/'


export const APIDevDomain = 'https://us-central1-exsportia-dev.cloudfunctions.net/develop/'
const APIStagingDomain = 'https://us-central1-exsportia-staging.cloudfunctions.net/staging/'
const APIProductionDomain = 'https://us-central1-exsportia-prod.cloudfunctions.net/production/'

type envDomainType = {
  URL: string
}

type APIDomainsMapType = {
  development: envDomainType
  staging: envDomainType
  preprod: envDomainType
  production: envDomainType
}

const APIDomainsMap: APIDomainsMapType = {
  development: {
    URL: APIDevDomain,
  },
  staging: {
    URL: APIStagingDomain,
  },
  preprod: {
    URL: APIStagingDomain,
  },
  production: {
    URL: APIProductionDomain,
  },
}
console.log('====> ~ APIDomainsMap:', APIDomainsMap)

const env = process.env.REACT_APP_ENV ?? 'development'
console.log('====> ~ env:', env)

// export const APIDomain = 'http://192.168.50.18:5001/exsportia-dev/us-central1/develop/'
// export const APIDomain = 'https://us-central1-exsportia-dev.cloudfunctions.net/develop/'
export const APIDomain = APIDomainsMap[env].URL
